
export enum DisputeCsvFileStatusCd {
	COMPLETED = 'Completed',
	FAILED = 'Failed',
	PROCESSING = 'Processing',
	SUBMITTED = 'Submitted'}

